<template>
  <g>
    <g transform="scale(0.8)">
      <text v-if="on" transform="matrix(1 0 0 1 105 -10)" class="rpm">rpm : {{rpm}}</text>
      <text transform="matrix(1 0 0 1 125 20)" class="name">DC모터{{getId}}</text>
      <path class="st0" d="M116.74,362v-52.29h21.02v-43.14C81.84,257.73,40,208.94,40,152C40,88.04,92.04,36,156,36s116,52.04,116,116
          c0,27.87-10.03,54.81-28.24,75.86c-17.46,20.18-41.31,33.73-67.4,38.36v43.5H197V362H116.74z M160.36,309.71v-41.8
          c-1.49,0.06-2.94,0.09-4.36,0.09c-0.74,0-1.48-0.01-2.24-0.02v41.73H160.36z"/>
      <g>
          <rect x="140.76" y="257.47" class="st1" width="10" height="61.43"/>
      </g>
      <g>
          <rect x="163.36" y="257.47" width="10" height="61.43"/>
      </g>
      <rect x="119.74" y="312.71" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 313.7381 671.7144)" class="st2" width="74.26" height="46.29"/>
      <g class="pin">
          <rect x="162.76" y="336.24" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 336.8206 683.78)" class="st3" width="11.3" height="11.3"/>
          <rect :id="`${pincode}MS`" @click="onClick(`${pincode}MS`)" class="pin-cover terminal" x="162.76" y="336.24" width="15" height="15"></rect>
          <text transform="matrix(1 0 0 1 150 380)" class="pin-name">GND</text>
      </g>
      <g class="pin">
          <rect x="140.16" y="336.24" transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 291.6206 683.78)" class="st3" width="11.3" height="11.3"/>
          <rect :id="`${pincode}PS`" @click="onClick(`${pincode}PS`)" class="pin-cover terminal" x="140.16" y="336.24" width="15" height="15"></rect>
          <text transform="matrix(1 0 0 1 130 380)" class="pin-name">VCC</text>
      </g>
      <circle class="st4" cx="156" cy="152" r="113"/>
      <g>
          <path class="st5" d="M204.79,224.28c-5.88-6.91-5.29-17.29,1.46-23.46c6.75-6.18,17.13-5.85,23.5,0.62l0.02-0.02l7.91,8.93
              c11.79-16.46,18.76-36.6,18.76-58.34c0-21.29-6.68-41.04-18.02-57.31l-7.51,6.65l-0.02-0.02c-6.91,5.88-17.29,5.29-23.46-1.46
              c-6.18-6.75-5.85-17.13,0.62-23.5l-0.02-0.02l6.59-5.84C198.1,58.6,177.86,51.56,156,51.56c-21.25,0-40.97,6.65-57.22,17.96
              l7.71,6.83l-0.02,0.02c6.46,6.37,6.79,16.75,0.62,23.5c-6.18,6.75-16.55,7.34-23.46,1.46l-0.02,0.02l-9.05-8.02
              C62.61,109.85,55.56,130.11,55.56,152c0,22.44,7.4,43.18,19.88,59.91l9.31-10.5l0.02,0.02c6.37-6.46,16.75-6.79,23.5-0.62
              c6.75,6.18,7.34,16.55,1.46,23.46l0.02,0.02l-9.77,11.03c16.02,10.8,35.3,17.12,56.03,17.12c21.41,0,41.25-6.75,57.57-18.21
              l-8.8-9.94L204.79,224.28z"/>
          <g>
              <path class="st6" d="M83.62,101.33c6.91,5.88,17.29,5.29,23.46-1.46c6.18-6.75,5.85-17.13-0.62-23.5l0.02-0.02l-7.71-6.83
                  c-9.36,6.51-17.56,14.58-24.23,23.81l9.05,8.02L83.62,101.33z"/>
          </g>
          <g>
              <path class="st6" d="M109.72,224.28c5.88-6.91,5.29-17.29-1.46-23.46c-6.75-6.18-17.13-5.85-23.5,0.62l-0.02-0.02l-9.31,10.5
                  c6.8,9.12,15.1,17.05,24.54,23.41l9.77-11.03L109.72,224.28z"/>
          </g>
          <g>
              <path class="st6" d="M237.69,210.34l-7.91-8.93l-0.02,0.02c-6.37-6.46-16.75-6.79-23.5-0.62c-6.75,6.18-7.34,16.55-1.46,23.46
                  l-0.02,0.02l8.8,9.94C222.89,227.69,231.05,219.6,237.69,210.34z"/>
          </g>
          <circle class="st7" cx="216.66" cy="213.01" r="10.79"/>
          <path class="st8" d="M220.37,210.69l-2.32,2.32l2.32,2.32c0.38,0.38,0.38,1.01,0,1.39c-0.38,0.38-1.01,0.38-1.39,0l-2.32-2.32
              l-2.32,2.32c-0.38,0.38-1.01,0.38-1.39,0s-0.38-1.01,0-1.39l2.32-2.32l-2.32-2.32c-0.38-0.38-0.38-1.01,0-1.39
              c0.38-0.38,1.01-0.38,1.39,0l2.32,2.32l2.32-2.32c0.38-0.38,1.01-0.38,1.39,0C220.75,209.69,220.75,210.31,220.37,210.69z"/>
          <circle class="st7" cx="94.87" cy="89.97" r="10.79"/>
          <path class="st8" d="M98.58,87.65l-2.32,2.32l2.32,2.32c0.38,0.38,0.38,1.01,0,1.39c-0.38,0.38-1.01,0.38-1.39,0l-2.32-2.32
              l-2.32,2.32c-0.38,0.38-1.01,0.38-1.39,0s-0.38-1.01,0-1.39l2.32-2.32l-2.32-2.32c-0.38-0.38-0.38-1.01,0-1.39
              c0.38-0.38,1.01-0.38,1.39,0l2.32,2.32l2.32-2.32c0.38-0.38,1.01-0.38,1.39,0C98.96,86.64,98.96,87.26,98.58,87.65z"/>
          <circle class="st7" cx="97.38" cy="213.01" r="10.79"/>
          <path class="st8" d="M101.09,210.69l-2.32,2.32l2.32,2.32c0.38,0.38,0.38,1.01,0,1.39c-0.38,0.38-1.01,0.38-1.39,0l-2.32-2.32
              l-2.32,2.32c-0.38,0.38-1.01,0.38-1.39,0c-0.38-0.38-0.38-1.01,0-1.39l2.32-2.32l-2.32-2.32c-0.38-0.38-0.38-1.01,0-1.39
              c0.38-0.38,1.01-0.38,1.39,0l2.32,2.32l2.32-2.32c0.38-0.38,1.01-0.38,1.39,0C101.47,209.69,101.47,210.31,101.09,210.69z"/>
          <g>
              <path class="st6" d="M204.2,81.14c-6.05,6.77-5.71,17.15,0.88,23.49c6.59,6.34,16.98,6.27,23.51-0.04l0.02,0.02l9.56-10.27
                  c-6.57-9.28-14.68-17.41-23.96-24.01l-10.04,10.78L204.2,81.14z"/>
          </g>
          <circle class="st7" cx="216.26" cy="92.71" r="10.79"/>
          <path class="st8" d="M212.49,94.94l2.37-2.26l-2.26-2.37c-0.37-0.39-0.36-1.02,0.03-1.39c0.39-0.37,1.02-0.36,1.39,0.03l2.26,2.37
              l2.37-2.26c0.39-0.37,1.02-0.36,1.39,0.03c0.37,0.39,0.36,1.02-0.03,1.39l-2.37,2.26l2.26,2.37c0.37,0.39,0.36,1.02-0.03,1.39
              c-0.39,0.37-1.02,0.36-1.39-0.03l-2.26-2.37l-2.37,2.26c-0.39,0.37-1.02,0.36-1.39-0.03C212.09,95.94,212.1,95.31,212.49,94.94z"/>
          <path class="st8" d="M179.62,64.9c-0.22-0.05-0.43-0.11-0.65-0.16c-14.23-3.33-29.3-3.33-43.53,0c-0.21,0.05-0.43,0.1-0.64,0.16
              c-1.8,0.58-3.11,2.28-3.11,4.27c0,0.33,0.04,0.65,0.1,0.95l0.18,0.61l2.8,9.6l0.36,1.24c0.71,1.55,2.27,2.63,4.09,2.63
              c0.2,0,0.4-0.01,0.59-0.04c0.27-0.06,0.55-0.13,0.82-0.19c10.85-2.43,22.31-2.43,33.16,0c0.27,0.06,0.54,0.12,0.81,0.19
              c0.19,0.03,0.39,0.04,0.59,0.04c1.81,0,3.37-1.07,4.08-2.62l0.36-1.25l2.8-9.6l0.17-0.59c0.07-0.31,0.11-0.63,0.11-0.97
              C182.73,67.18,181.43,65.48,179.62,64.9z"/>
          <path class="st8" d="M179.62,240.77c-0.22,0.05-0.43,0.11-0.65,0.16c-14.23,3.33-29.3,3.33-43.53,0c-0.21-0.05-0.43-0.1-0.64-0.16
              c-1.8-0.58-3.11-2.28-3.11-4.27c0-0.33,0.04-0.65,0.1-0.95l0.18-0.61l2.8-9.6l0.36-1.24c0.71-1.55,2.27-2.63,4.09-2.63
              c0.2,0,0.4,0.01,0.59,0.04c0.27,0.06,0.55,0.13,0.82,0.19c10.85,2.43,22.31,2.43,33.16,0c0.27-0.06,0.54-0.12,0.81-0.19
              c0.19-0.03,0.39-0.04,0.59-0.04c1.81,0,3.37,1.07,4.08,2.62l0.36,1.25l2.8,9.6l0.17,0.59c0.07,0.31,0.11,0.63,0.11,0.97
              C182.73,238.5,181.43,240.19,179.62,240.77z"/>
          <path class="st8" d="M245.15,175.25c0.05-0.22,0.11-0.43,0.16-0.65c3.33-14.23,3.33-29.3,0-43.53c-0.05-0.21-0.1-0.43-0.16-0.64
              c-0.58-1.8-2.28-3.11-4.27-3.11c-0.33,0-0.65,0.04-0.95,0.1l-0.61,0.18l-9.6,2.8l-1.24,0.36c-1.55,0.71-2.63,2.27-2.63,4.09
              c0,0.2,0.01,0.4,0.04,0.59c0.06,0.27,0.13,0.55,0.19,0.82c2.43,10.85,2.43,22.31,0,33.16c-0.06,0.27-0.12,0.54-0.19,0.81
              c-0.03,0.19-0.04,0.39-0.04,0.59c0,1.81,1.07,3.37,2.62,4.08l1.25,0.36l9.6,2.8l0.59,0.17c0.31,0.07,0.63,0.11,0.97,0.11
              C242.88,178.35,244.57,177.05,245.15,175.25z"/>
          <path class="st8" d="M69.28,175.25c-0.05-0.22-0.11-0.43-0.16-0.65c-3.33-14.23-3.33-29.3,0-43.53c0.05-0.21,0.1-0.43,0.16-0.64
              c0.58-1.8,2.28-3.11,4.27-3.11c0.33,0,0.65,0.04,0.95,0.1l0.61,0.18l9.6,2.8l1.24,0.36c1.55,0.71,2.63,2.27,2.63,4.09
              c0,0.2-0.01,0.4-0.04,0.59c-0.06,0.27-0.13,0.55-0.19,0.82c-2.43,10.85-2.43,22.31,0,33.16c0.06,0.27,0.12,0.54,0.19,0.81
              c0.03,0.19,0.04,0.39,0.04,0.59c0,1.81-1.07,3.37-2.62,4.08l-1.25,0.36l-9.6,2.8l-0.59,0.17c-0.31,0.07-0.63,0.11-0.97,0.11
              C71.55,178.35,69.86,177.05,69.28,175.25z"/>
      </g>
      <g>
          <g>
              <circle class="st6" cx="157.26" cy="152.84" r="59.01"/>
          </g>
          <circle class="st7" cx="157.26" cy="152.84" r="48.97"/>
          <circle class="st8" cx="157.26" cy="152.84" r="20.09"/>
      </g>
      <g id="servo-fan">
          <path class="st9" d="M249.96,134.11l-4.68-0.27l-66.12-3.88v-0.01h0l-4.12-67.49l-0.14-2.25C173.71,45.99,165.88,35,156.38,35
              c-9.23,0-16.89,10.38-18.41,24.03l-0.27,4.68l-3.89,66.24h0v0.01l-67.36,4.11l-2.25,0.14c-14.23,1.2-25.22,9.03-25.22,18.52
              c0,9.23,10.38,16.89,24.03,18.41l4.68,0.27l66.12,3.88v0.01h0.02l4.1,67.24l0.14,2.25c1.2,14.23,9.03,25.22,18.52,25.22
              c9.23,0,16.89-10.38,18.41-24.03l0.27-4.68l3.87-65.99h0.02v-0.01l67.36-4.11l2.25-0.14c14.23-1.2,25.22-9.03,25.22-18.52
              C273.99,143.29,263.6,135.63,249.96,134.11z M75.37,156.62c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4
              C79.37,154.83,77.58,156.62,75.37,156.62z M95.37,156.62c-1.36,0-2.55-0.68-3.27-1.71c-0.45-0.65-0.73-1.44-0.73-2.29
              c0-0.84,0.26-1.62,0.71-2.26c0.72-1.05,1.93-1.74,3.29-1.74c2.21,0,4,1.79,4,4C99.37,154.83,97.58,156.62,95.37,156.62z
              M115.37,156.62c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4C119.37,154.83,117.58,156.62,115.37,156.62z
              M156.49,237.62c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4C160.49,235.83,158.7,237.62,156.49,237.62z M158.77,216.89
              c-0.65,0.45-1.44,0.73-2.29,0.73c-0.84,0-1.62-0.26-2.26-0.71c-1.05-0.72-1.74-1.93-1.74-3.29c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4
              C160.49,214.98,159.81,216.17,158.77,216.89z M156.49,197.62c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4
              C160.49,195.83,158.7,197.62,156.49,197.62z M156.49,67.38c2.21,0,4,1.79,4,4c0,2.21-1.79,4-4,4c-2.21,0-4-1.79-4-4
              C152.49,69.17,154.28,67.38,156.49,67.38z M154.2,88.11c0.65-0.45,1.44-0.73,2.29-0.73c0.84,0,1.62,0.26,2.26,0.71
              c1.05,0.72,1.74,1.93,1.74,3.29c0,2.21-1.79,4-4,4c-2.21,0-4-1.79-4-4C152.49,90.02,153.17,88.83,154.2,88.11z M156.49,107.38
              c2.21,0,4,1.79,4,4c0,2.21-1.79,4-4,4c-2.21,0-4-1.79-4-4C152.49,109.17,154.28,107.38,156.49,107.38z M197.61,156.63
              c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4C201.61,154.83,199.81,156.63,197.61,156.63z M220.9,154.89
              c-0.72,1.05-1.93,1.74-3.29,1.74c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4c1.36,0,2.55,0.68,3.27,1.71c0.45,0.65,0.73,1.44,0.73,2.29
              C221.61,153.47,221.34,154.25,220.9,154.89z M237.61,156.63c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4
              C241.61,154.83,239.81,156.63,237.61,156.63z"/>
          <g>
              <circle class="st10" cx="156.49" cy="152.63" r="8.06"/>
              <polygon class="st11" points="161.16,149.82 159.29,147.95 156.49,150.76 153.68,147.95 151.81,149.82 154.62,152.63
                  151.81,155.43 153.68,157.3 156.49,154.49 159.29,157.3 161.16,155.43 158.36,152.63 "/>
          </g>
      </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

const map = function (val, a, b, c, d) {
  return ((val - a) / (b - a)) * (d - c) + c
}
export default {
  props: ['data'],
  mixins: [pins],
  name: 'DCMotor',
  data () {
    return {
      on: false,
      socket: null,
      isRotating: 'init',
      timemax1: null,
      timemax2: null,
      timemax3: null,
      rpm: 0
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    initTimeLine () {
      if (this.timemax1 != null && this.timemax2 != null) return
      // clockwise
      this.timemax1 = new window.TimelineMax({ repeat: -1 })
      this.timemax1.to(`#${this.data.id} #servo-fan`, 1, {
        rotation: 360,
        transformOrigin: '50% 50%',
        ease: 'none'
      })

      // counter-clockwise
      this.timemax2 = new window.TimelineMax({ repeat: -1 })
      this.timemax2.to(`#${this.data.id} #servo-fan`, 1, {
        rotation: -360,
        transformOrigin: '50% 50%',
        ease: 'none'
      })

      this.timemax3 = new window.TimelineMax()
      this.timemax3.to(`#${this.data.id} #servo-fan`, 1, {
        rotation: -360,
        transformOrigin: '50% 50%',
        ease: window.Power4.out
      })
    },
    start (socket) {
      this.socket = socket
      this.on = true
      this.initTimeLine()
      this.socket.onmessage = ({ data }) => {
        data = JSON.parse(data)
        this.rpm = data.value
        this.rotateFan(this.rpm)
      }
    },
    off () {
      this.socket = null
      this.on = false
      if (this.timemax1) this.timemax1.timeScale(0)// window.gsap.to(this.timemax1, { timeScale: 0 })
      if (this.timemax2) this.timemax2.timeScale(0)// window.gsap.to(this.timemax2, { timeScale: 0 })
    },
    rotateFan (rpm) {
      if (this.on) {
        const speed = Math.round(map(Math.abs(rpm), 0, 10000, 0, 40)) / 10
        if (rpm > 0) {
          this.timemax1.timeScale(speed)
          this.timemax2.timeScale(0)
        } else if (rpm === 0 || rpm === -99999) {
          this.timemax1.timeScale(0)
          this.timemax2.timeScale(0)
        } else {
          this.timemax2.timeScale(speed)
          this.timemax1.timeScale(0)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover{
  display: block;
  stroke: none;
  fill: none;
}
.pin-name{
  display: none;
}
.pin:hover{
  cursor: pointer;
  .pin-cover{
    stroke-width: 3px;
    stroke: black;
    fill: #ff6f61;
  }
  .pin-name{
    display: block;
    font-size: 20px;
  }
}
.selected{
  & path.st0{
    display: block;
    fill: #ff6f61;
  }
}
.name{font-size: 20px}
.rpm{font-size: 25px; fill: #D80034;}
.st0{fill:#D6D6D6; display: none;}
.st1{fill:#D80034;}
.st2{fill:#3D3C44;}
.st3{stroke:#575058;stroke-width:2;stroke-miterlimit:10;}
.st4{fill:#ADADAD;}
.st5{fill:#BFBFBF;}
.st6{fill:#CCCCCC;}
.st7{fill:#A5A5A5;}
.st8{fill:#4C4C4C;}
.st9{fill:#F2D144;}
.st10{fill:#B3B3B3;}
.st11{fill:#666666;}
</style>
